<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Exportation des reparations</h1>
    <div class="mb-6 flex justify-between items-center">
      <div class="flex">
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-hidden max-w-7xl pt-4">
      <form @submit.prevent="submit">
        <div class="md:inline-flex space-y-4 md:space-y-0 w-full py-4 px-6 items-center">
          <h2 class="md:w-1/3 max-w-sm mx-auto font-medium text-gray-500 text-lg">Date:</h2>
          <div class="md:w-2/3 mx-auto">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-2">
                <label>Debut:</label>
                <input type="date" v-model='fromDate' class="border border-gray-200 p-2">
              </div>
              <div class="col-span-6 sm:col-span-2">
                <label>Fin:</label>
                <input type="date" v-model='toDate' class="border border-gray-200 p-2">
              </div>
              <div class="col-span-6 sm:col-span-2">
                <loading-button :loading="submiting" class="btn-indigo mx-2" type="submit">Exporter</loading-button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="space-y-4 md:space-y-0 w-full py-4 px-6 items-center">
        <h2 class="max-w-sm w-3/12 mx-auto font-medium text-gray-500 text-lg text-center pb-6">Reparations en attente:</h2>
        <loading-button :loading="sending" class="btn-indigo mx-auto my-0" type="submit" @click.native="exportPending">Exporter</loading-button>
      </div>

    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import LoadingButton from '@/Shared/LoadingButton'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Input from "../../Jetstream/Input";

export default {
  metaInfo: {title: 'Exportation des reparations'},
  layout: Layout,
  components: {
    Input,
    Icon,
    LoadingButton,
    SearchFilter,
  },
  props: {
    filters: Object,
  },
  data() {
    return {
      fromDate : new Date().toISOString().slice(0,10),
      toDate : new Date(Date.now() - 86400000).toISOString().slice(0,10),
      sending: false,
      submiting: false,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('dashboard.repairsExtract', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    exportPending() {
      window.open(this.route('dashboard.exportRepairs'), "_blank");
    },
    submit() {
      window.open(this.route('dashboard.exportByDate', [this.fromDate, this.toDate]), "_blank");
    },
  },
}
</script>
